const colors = {
  headColor: "#01917E",
  statusHeadFontColor: "#01917E",
  headFontColor: "ffffff",
  btnHoverColor: "rgba(5, 167, 146, 0.08)",
  dropAnchorPointBtn: "#E4485B",
  anchorPointBtnBorder: "#CF3F50",
  address: "#D8D6D6",
};
const styles = {
  popupContainer : {
    paddingBottom : 4
  },
  root: {
    width: "260px",
    height: "165px",
  },
  pickupMarker: {
    marginTop: 5,
    paddingLeft: 10,
  },
  anchorPointRoot: {
    width: "200px",
    // height:"138px"
    paddingBottom: 12,
  },
  table: {
    height: "100%",
    width: "100%",
  },
  tableHead: {
    backgroundColor: colors.headColor,
  },
  tableHeadHeight: {
    height: "52px",
    "& $tableHeaderCell": {
      paddingTop: "6px",
    },
  },
  tableHeaderCell: {
    color: colors.headFontColor,
    borderBottom: 0,
    fontSize: "12px",
  },
  tableHeadCell: {
    color: colors.headFontColor,
    borderBottom: 0,
    fontSize: "12px",
  },
  tableCellBorder: {
    border: "none",
  },
  tableRowRoot: {
    height: "25px",
  },
  anchorPointTableRowRoot: {
    height: 24,
    "& $anchorPointBtnCell": {
      borderBottom: "0px",
      paddingTop: 8,
      paddingLeft: "14px",
    },
    "& $labelCell, & $dataCell": {
      paddingTop: 8,
    },
    "& $dataCell": {
      display: "block",
      width: 100,
      paddingRight: 12,
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      boxSizing: "border-box",
      paddingLeft: 2,
    },
  },
  routeInfo: {
    float: "right",
    fontSize: "10px",
    paddingRight: "12px",
  },
  accountNumber: {
    float: "right",
    fontSize: "12px",
    paddingRight: "6px",
  },
  customerName: {
    float: "left",
    paddingLeft: "6px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    lineHeight: "17px",
    width: "130px",
    textOverflow: "ellipsis",
  },
  address: {
    clear: "both",
    fontSize: "10px",
    lineHeight: "20px",
    color: colors.address,
    paddingLeft: "6px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    height: "20px",
    width: "180px",
    textOverflow: "ellipsis",
    display: "inline-block",
  },
  firstTableCell: {
    paddingTop: "5px",
  },
  lastTableCell: {
    paddingRight: "10px",
  },
  popupDataStyle: {},
  labelCell: {
    width: 125,
    borderBottom: 0,
    fontSize: 12,
    paddingLeft: "12px",
    lineHeight: "14px",
  },

  lastLabelCell: {
    width: "154px",
    borderBottom: 0,
    fontSize: 10,
    paddingLeft: "12px",
    lineHeight: "14px",
  },
  dataCell: {
    borderBottom: 0,
    fontSize: 12,
    width: "82px",
    //fontWeight:600,
    lineHeight: "17px",
    "&$firstTableCell": {
      paddingTop: "5px",
    },
    "&$lastTableCell": {
      // paddingBottom: "7px",
      paddingRight: "10px",
    },
    "&$popupDataStyle": {
      paddingLeft: "12px",
      paddingRight: "10px",
    },
  },
  nameCellPadding: {
    paddingRight: "12px",
  },
  routePopupButton: {
    paddingRight: "5px",
  },
  popupButton: {
    fontSize: 9,
    padding: "0px",
    borderColor: colors.headColor,
    color: colors.headColor,
    fontWeight: "600",
    borderRadius: "2px",
    height: "25px",
    width: "101px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: colors.btnHoverColor,
    },
  },
  anchorPointBtn: {
    fontSize: 9,
    borderRadius: "2px",
    borderColor: colors.anchorPointBtnBorder,
    color: colors.dropAnchorPointBtn,
    height: "25px",
    width: "90%",
    fontWeight: "600",
    textTransform: "none",
  },

  routeNameInfo: {
    float: "left",
    paddingLeft: "12px",
  },
  startTime: {
    fontSize: "10px",
    lineHeight: "14px",
    float: "right",
    paddingRight: "12px",
  },
  headHeight: {
    height: "34px",
  },
  disabled: {
    cursor: "not-allowed",
    "& $disabledBtn": {
      borderColor: colors.anchorPointBtnBorder,
      color: colors.dropAnchorPointBtn,
    },
  },
  disabledBtn: {},
  progress: {
    color: colors.dropAnchorPointBtn,
  },
  rightCell: {
    width: 100,
  },

  nearbyRoutesLabel: {
    textDecoration: "underline",
    "&:hover": {
      opacity: "0.8",
    },
  },
  zonePopUp: {
    width: "180px",
  },
  SpecialInstruction: {
    width: "100px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  dualCellLeft: {
    display: "inline-block",
    paddingRight: "10px",
  },
  dualCellRight: {
    display: "inline-block",
    paddingLeft: "10px",
    borderLeft: "1px solid #D8D8D8",
  },
  popupIconContainer: {
    float: "right",
    paddingRight: "10px",
    paddingTop: "3px",
  },
  popupIcon: {
    display: "inline-block",
    paddingLeft: "3px",
    fontSize: "11px",
    fontWeight: "100",
  },
  routeStop: {
    width: "230px",
  },
  recommendationButton: {
    margin: 5,
    marginLeft: 116,
    fontSize: 12,
    textTransform: "none",
    backgroundColor: "#05A792",
    marginBottom: 10,
    "&:hover": {
      backgroundColor: "#05A792",
    },
  },

  checkbox: {
    "&$checked": {
      color: "#05A792",
    },
    color: "#05A792",
    padding: 0,
    paddingLeft: 7,
    paddingBottom: 7,
  },
  checked: {},

  deliveryMarker: {
    marginTop: 5,
    paddingLeft: 10,
  },
  statusHeaderCell: {
    color: colors.statusHeadFontColor,
    borderBottom: 0,
    fontSize: "12px",
    paddingLeft: "10px",
  },
  eta: {
    color: "#01917E",
    fontWeight: 600,
  },
  driverName: {
    width: "110px",
    borderBottom: 0,
    fontSize: 12,
    paddingLeft: "12px",
    lineHeight: "14px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  firstTableCell: {
    paddingTop: "10px",
  },
  lastTableCellStopPopup: {
    paddingBottom: "15px",
  },
  popupDataStyle: {},
  labelCellStopPopup: {
    width: "132px",
    borderBottom: 0,
    fontSize: 12,
    paddingLeft: "12px",
    lineHeight: "14px",
  },
  tableButtonCell: {
    borderBottom: "0px",
    padding: "0px 4px 12px 10px",
    "&$tableButtonRight": {
      padding: "0px 10px 12px 4px",
    },
  },
  tableButtonRight: {},
  anchorPointBtnCell: {},
  nearbyRoutesStyle: {
    fontSize: "9px",
    lineHeight: "13px",
    color: colors.headColor,
    paddingLeft: "12px",
  },
  editIcon: {
    fontSize: "14px",
    paddingLeft: "4px",
  },
  terminalName: {
    fontWeight: 600,
    fontSize: "10px",
    lineHeight: "14px",
    textDecorationLine: "underline",
    paddingLeft: "44px",
  },
  TerminalClickClass: {
    paddingBottom: "10px",
    display: "flex",
  },
};

export default styles;
